<div class="d-flex flex-column gap-4">
  <!-- FILTERS -->
  <app-dea-widget-wrapper>
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex flex-row gap-1 align-items-center">
        <button class="d-flex align-items-center dea-icon-btn" type="button" color="secondary" mat-icon-button
          aria-label="Indietro" title="Indietro" (click)="goBackOnePage()">
          <i class="bi bi-chevron-left"></i>
        </button>
        <div class="fw-semibold">Statistiche:</div>
      </div>
      <form [formGroup]="filterForm" class="d-flex flex-row gap-4">
        <mat-radio-group formControlName="type" class="d-flex flex-row gap-2 align-items-start" color="primary">
          <mat-radio-button value="year" class="text-nowrap">Anno Solare</mat-radio-button>
          <mat-radio-button value="school_year" class="text-nowrap">Anno Scolastico</mat-radio-button>
        </mat-radio-group>
        <div *ngIf="filterForm.get('type')?.value === 'school_year'" style="width: 180px;">
          <select class="form-control dea-form-input" formControlName="school_year">
            <option *ngFor="let schoolYear of schoolYears$ | async;" [value]="schoolYear">
              {{schoolYear}}
            </option>
          </select>
        </div>
        <div *ngIf="filterForm.get('type')?.value === 'year'" style="width: 180px;">
          <input type="number" formControlName="year" class="form-control dea-form-input" min="1900" max="2099"
            step="1" />
        </div>
        <select class="form-control dea-form-input" formControlName="category" style="max-width: 180px;">
          <option [value]="null">Tutte</option>
          <option *ngFor="let category of categoriesOptions$ | async;" [value]="category.value">
            {{category.label}}
          </option>
        </select>
      </form>
    </div>
  </app-dea-widget-wrapper>
  <!-- FILTERS -->
  <!-- LINES -->
  <app-dea-widget-wrapper>
    <canvas id="graficoLineeDivisioneMesi" style="width: 100%; max-height: 450px !important;">
      {{graficoLineeDivisioneMesi}}
    </canvas>
  </app-dea-widget-wrapper>
  <!-- LINES -->
  <!-- CATEGORIES -->
  <app-dea-widget-wrapper>
    <canvas id="graficoLineeDivisioneCategorie" style="width: 100%; max-height: 80vh !important;">
      {{graficoLineeDivisioneCategorie}}
    </canvas>
  </app-dea-widget-wrapper>
  <!-- CATEGORIES -->
</div>
